import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReferralDetail } from "../../../domain/entities/referral-backoffice";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getReferral = createAsyncThunk<
  ReferralDetail,
  { referralId: string; supervisorId?: string },
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_REFERRAL, async ({ referralId, supervisorId }, { extra }) => {
  return await extra.referralsBackofficeRepo.get(referralId, supervisorId);
});
